"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRootElement = void 0;
var react_1 = require("react");
var dom_1 = require("@r1-frontend/shared/helpers/dom");
/**
 * Coздает элемент в корне документа или возвращает
 * ссылку на него, если он существует
 */
var useRootElement = function (_a) {
    var id = _a.id, tag = _a.tag;
    var _b = __read((0, react_1.useState)(null), 2), rootElement = _b[0], setRootElement = _b[1];
    (0, react_1.useEffect)(function () {
        if (rootElement) {
            return;
        }
        var element = (0, dom_1.createRootElement)(id, tag);
        setRootElement(element);
    }, [id, tag, rootElement]);
    return rootElement;
};
exports.useRootElement = useRootElement;
